import Axios from 'axios'
import { Manifest } from 'grosella/manifest'

type OptionalFeatures = {
    hidePoweredByLogixboard: boolean
    showMbl: boolean
}

const isOptionalFeatureEnabled = (optFeatureValue: string) => {
    return optFeatureValue === 'ENABLED'
}

export const fetchOptionalFeatures = async (
    tenantId: string
): Promise<OptionalFeatures> => {
    const response = await Axios.post(
        `${Manifest.services.dragonFruit}/anon/graphql`,
        {
            operationName: 'AnonOptionalFeatures',
            query: `
                query AnonOptionalFeatures($tenantId: UUID!) {
                    anonOptionalFeatures(tenantId: $tenantId)
                }
        `,
            variables: {
                tenantId: tenantId,
            },
        }
    )

    return {
        hidePoweredByLogixboard: isOptionalFeatureEnabled(response.data.data.anonOptionalFeatures.hidepoweredbylogixboard),
        showMbl: isOptionalFeatureEnabled(response.data.data.anonOptionalFeatures.show_mbl),
    }
}
